import { type ForwardedRef, forwardRef, type InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";
import { InputRoot } from "./InputRoot";
import { generatePlaceholder } from "./utils/generatePlaceholder";

export const InputPassword = forwardRef(
  (
    props: InputHTMLAttributes<HTMLInputElement>,
    ref: ForwardedRef<HTMLInputElement>,
  ) => (
    <InputRoot
      ref={ref}
      {...props}
      type="password"
      autoComplete={props.autoComplete ?? "current-password"}
      className={twMerge("w-full", props.className)}
      placeholder={generatePlaceholder(props.placeholder)}
    />
  ),
);

InputPassword.displayName = "InputPassword";
